import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import type { IEquipmentSettingsList } from '../model/equipmentSettingsList';

export const equipmentSettingsListKey = () => ['equipmentSettingsList'];
export const equipmentSettingsListFn = () =>
  apiClient.get(`${APP_API_URL_V2}fsd/action-item/cost-savings-settings/list`);

const equipmentSettingsListSelect = ({ data }: AxiosResponse<{ data: IEquipmentSettingsList }>) => data.data;

export const useEquipmentSettingsListQuery = () => {
  return useQuery({
    queryKey: equipmentSettingsListKey(),
    queryFn: equipmentSettingsListFn,
    select: equipmentSettingsListSelect,
  });
};
